import { ENDPOINTS } from "../config";
import { generateRequest } from "../utils";

export async function fetchDisclaimers(): Promise<{}[]> {
    let response = [];
	let request = await fetch(ENDPOINTS.config.listdisclaimers, generateRequest("POST", {}));
    if (request.ok) {
            response["data"] = [...await request.json()];
    } else {
        response["error"] = new Error(request.statusText);
    }
    return response;
}




// WEBPACK FOOTER //
// ./src/client/data/listDisclaimers.ts